import { c as _c } from "react/compiler-runtime";
import { Chip, classNames } from "@opensea/ui-kit";
import { ModifierKey } from "./ModifierKey";
export function Key(t0) {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  if (children === "MODIFIER") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ModifierKey />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = children.length === 1 ? "aspect-square" : "px-1";
  let t2;
  if ($[1] !== className || $[2] !== t1) {
    t2 = classNames("justify-center p-0 uppercase", t1, className);
    $[1] = className;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <Chip className={t2}>{children}</Chip>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}